import { Popup } from '@repo/design-system-kit';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'clsx';
import { useSegment } from '@repo/poly-hooks/segment';
import { ConfirmDeviceSvg } from '../../../svgs/confirm-device';
import { faqService } from '../../../utils/faq-composer';
import styles from './risky-login.module.css';

interface VerifyDeviceProps {
  onClose?: () => void;
}

export function VerifyDevice({ onClose }: VerifyDeviceProps): React.ReactNode {
  // NOTE -- this is needed until we have a better way to handle the portal container in qunit tests
  // https://www.notion.so/qonto/React-popover-library-used-within-react-aria-components-does-mount-popovers-modals-outside-of-qunit--12631ee4c696806e87dbef81e9a27922
  const TEST_PORTAL_CONTAINER = document.getElementById('ember-testing') ?? undefined;
  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();
  const segment = useSegment();
  const handleClose = (): void => {
    onClose?.();
    setIsOpen(false);
  };

  useEffect(() => {
    segment.track('device_confirmation_started');
  }, [segment]);

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'sca.sensitive-actions.accordion.confirm-device.title' })}
      data-testid="verify-device"
      isOpen={isOpen}
      portalContainer={TEST_PORTAL_CONTAINER}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure className={styles.illustrationWrap}>
          <ConfirmDeviceSvg />
        </figure>
        <Popup.Title>
          <FormattedMessage id="sca.sensitive-actions.accordion.confirm-device.title" />
        </Popup.Title>
        <Popup.Body>
          <p className={cx('body-standard ', styles.faqLink)}>
            <FormattedMessage
              id="sca.sensitive-actions.accordion.confirm-device.subtitle"
              values={{
                a: (chunks: React.ReactNode) => (
                  <a
                    href={faqService.getLocalizedArticle('how_to_pair_my_phone')}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </p>
        </Popup.Body>
      </Popup.Header>
    </Popup.Root>
  );
}
